import React from 'react'
import ModalWrapper from '../ModalWrapper'
import AccountAuthenticationContainer from '../../../containers/account/AccountAuthenticationContainer'

const AccountAuthenticationModal= props => {


	return (
		<div className='accountAuthentication-modal'>
			<ModalWrapper
				{...props}
				title={(props.googleUser ? 'Add Google Sign-in' : 'Google Sign-in')}
				iconName='googleLogo'
				modalStyle='light'
				closeBtn={false}
			>
			<AccountAuthenticationContainer {...props} />
	</ModalWrapper>
	</div>
	)
}

export default AccountAuthenticationModal


// WEBPACK FOOTER //
// ./src/components/modals/account/AccountAuthenticationModal.js